import { z } from "zod";
import { materialTypeEnumSchema } from "../enumSchemas"

const apiMaterialSchema = z.object({
    materialType: materialTypeEnumSchema,
    id: z.number()
  });

export default apiMaterialSchema;